module.exports = __webpack_public_path__ + "img/album14_13.4c43f8ba.jpg";